export default {
  wrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    background: '#eee',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  imgWrap: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
    boxSizing: 'border-box',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    scrollBehavior: 'smooth',
    scrollSnapAlign: 'center',
  },
  canvas: {
    position: 'relative',
    overflow: 'hidden',
    transformOrigin: 'top left',
    cursor: 'crosshair',
    transition: 'all 0.3s',
  },
  board: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    userSelect: 'none',
  },
  textBox: {
    display: 'flex',
  },
  text: {
    fontWeight: 600,
    textAlign: 'center',
    // fontSize: '1.35em',
    padding: '0.5em',
    width: '100%',
    maxWidth: 280,
    color: 'red',
    borderRadius: 20,
    backgroundColor: '#e0e0e0',
    margin: '20px auto',
  },
  btnWrap: {
    whiteSpace: 'nowrap',
  },
  vAlign: {
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    boxSizing: 'border-box',
  },
  buttons: {
    textAlign: 'center',
    position: 'relative',
    minHeight: 40,
    '& span': {
      display: 'inline-block',
      paddingBottom: 10,
    },
    '& img': {
      marginRight: 10,
    },
  },
  action: {
    position: 'absolute',
    right: 20,
    bottom: 15,
    cursor: 'pointer',
  },
};
